import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface IncomingCallsState {
  isOpen: boolean;
  incomingCallsList:
    | {
        id: string;
        from: string;
        to: string;
        time: string;
        status: string;
      }[]
    | null;
}

const initialState: IncomingCallsState = {
  isOpen: false,
  incomingCallsList: [],
};

const incomingCallsSlice = createSlice({
  name: "incomingCalls",
  initialState,
  reducers: {
    addNewIncomingCallData: (state, action: PayloadAction<any>) => {
      state.isOpen = true;
      if (state.incomingCallsList) {
        state.incomingCallsList.unshift(action.payload);
      } else {
        state.incomingCallsList = [action.payload];
      }
    },
    updateIncomingCallData: (
      state,
      action: PayloadAction<{
        id: string;
        status: string;
      }>
    ) => {
      if (state.incomingCallsList) {
        state.incomingCallsList = state.incomingCallsList.map((call) =>
          call.id === action.payload.id
            ? { ...call, ...action.payload }
            : call
        );
      }
    },
    deleteIncomingCallData: (
      state,
      action: PayloadAction<{
        id: string;
      }>
    ) => {
      if (state.incomingCallsList) {
        state.incomingCallsList = state.incomingCallsList.filter(
          (call) => call.id !== action.payload.id
        );
      }
    },
    closeIncomingCalls: (state) => {
      state.isOpen = false;
      //   state.callData = [];
    },
    openIncomingCalls: (state) => {
      state.isOpen = true;
      //   state.callData = [];
    },
  },
});

export const {
  addNewIncomingCallData,
  closeIncomingCalls,
  openIncomingCalls,
  deleteIncomingCallData,
  updateIncomingCallData
} = incomingCallsSlice.actions;
export default incomingCallsSlice.reducer;
